import { createIcon } from '@chakra-ui/react';
import { jsx as _jsx } from "react/jsx-runtime";
export var SpeakerMute = createIcon({
  displayName: 'SpeakerMute',
  viewBox: '0 0 24 24',
  path: [/*#__PURE__*/_jsx("path", {
    d: "M3 15.6979H7.7L6.7 16.7482H2.5C2.2 16.7482 2 16.5382 2 16.2231V7.82036C2 7.50526 2.2 7.29519 2.5 7.29519H7.8L13.2 2.14854C13.3 2.04351 13.5 1.93847 13.7 2.04351C13.9 2.14854 14 2.35861 14 2.56867V8.97573L13 10.0261V3.72405L8.3 8.2405C8.2 8.34553 8.1 8.34553 8 8.34553H3V15.6979Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M21.1 4.5644L19.4 6.34998C21 7.71541 22 9.71105 22 12.0218C22 16.1181 18.9 19.3742 15 19.3742V18.3238C18.3 18.3238 21 15.4879 21 12.0218C21 10.0262 20.1 8.24058 18.6 7.08521L16.8 8.97582C17.8 9.60602 18.4 10.7614 18.4 12.0218C18.4 14.0174 16.8 15.698 14.9 15.698V14.6476C16.3 14.6476 17.4 13.4923 17.4 12.0218C17.4 10.9715 16.9 10.1312 16.1 9.71105L13.9 12.0218V21.4748C13.9 21.6849 13.8 21.895 13.6 22H13.4C13.3 22 13.2 22 13.1 21.895L8.6 17.5886L4.8 21.5799C4.6 21.7899 4.3 21.7899 4.1 21.5799C3.9 21.3698 3.9 21.0547 4.1 20.8446L20.4 3.82917C20.6 3.6191 20.9 3.6191 21.1 3.82917C21.3 4.03923 21.3 4.35434 21.1 4.5644ZM13 20.3195L9.4 16.8533L13 13.0721V20.3195Z",
    fill: "currentColor"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15 4.66944C15.9 4.66944 16.8 4.8795 17.6 5.1946L16.8 6.03487C16.3 5.82481 15.6 5.71977 15 5.71977V4.66944Z",
    fill: "currentColor"
  })]
});
//# sourceMappingURL=SpeakerMute.js.map